const NoLayout: React.FC = ({ children }) => (
  <>
    {children}
  </>
);

export default NoLayout;